export const LOAD_USER = 'LOAD_USER'
export const VERIFY_ROLE = 'VERIFY_ROLE'
